module.exports = __webpack_public_path__ + "img/1.6dec3a28.jpg";